import axios from "axios";
import {getNodeInductServiceBaseURL} from "./BaseURLUtils";
import {authInterceptorBuilder} from "./Interceptors";
import {
    publishCountToDolphinCSM,
    publishLatencyToDolphinCSM,
    emitAnalyticsEvent
} from "../../helper/PUMAMetricHelper";

export function getNISClient() {
    const axiosNISClient = axios.create({
        baseURL: getNodeInductServiceBaseURL()
    });

    const authInterceptor = authInterceptorBuilder(axiosNISClient);

    axiosNISClient.interceptors.request.use(authInterceptor.onBeforeRequest, authInterceptor.onRequestError);

    axiosNISClient.interceptors.response.use(authInterceptor.onResponseSuccess, authInterceptor.onResponseError);
    return axiosNISClient;
}

export async function axiosPOST(metricName, path, requestData) {
    let startTime = Date.now();
    try {
        publishCountToDolphinCSM(metricName);
        const response = await getNISClient().post(path, requestData);
        publishLatencyToDolphinCSM(startTime, metricName);
        return response;
    } catch(error) {
        publishErrorMetric(metricName, startTime, error);
        throw error;
    }
}

export async function axiosGET(metricName, path, params) {
    let startTime = Date.now();
    try {
        publishCountToDolphinCSM(metricName);
        const response = await getNISClient().get(path, params);
        publishLatencyToDolphinCSM(startTime, metricName);
        return response;
    } catch(error) {
        publishErrorMetric(metricName, startTime, error);
        throw error;
    }
}

export function publishErrorMetric(metricName, startTime, error) {

    //Emitting Error stack trace
    emitAnalyticsEvent(metricName, error);

    //Emitting Failure Metrics
    publishLatencyToDolphinCSM(startTime, metricName);
    publishCountToDolphinCSM(metricName+"-failure");
    if (error.status >= 400 && error.status < 500) {
        publishCountToDolphinCSM("4xxError");
    }
    else {
        publishCountToDolphinCSM("5xxError");
    }
}





// WEBPACK FOOTER //
// ./src/components/utils/network/NetworkUtils.js